import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-variant-summary',
  templateUrl: './variant-summary.component.html',
  styleUrls: ['./variant-summary.component.scss']
})
export class VariantSummaryComponent implements OnInit {
  public isShowVariantDetails = false;
  public variantDetails: [] = [];
  public variant: any;
  public tableHeaders: [] = [];
  public tableTit:any = [];
  public tableTit1:any = [];
  public tableTit2: any = [];
  public tabData: any = [];
  public tabData1: any = [];
  public tabData2: any = [];
  public objectList: any = [];
  public tableData1: any = [];
  public tableData2: any = [];
  constructor(public service: ApifirstService) { }

  ngOnInit(): void {
    this.getApiCall();
  }
  getApiCall() {
    this.service.getVariantDetails().subscribe((data) => {
      this.variantDetails = data
    })
  }
  indexValue:any
  showArray: any = []
  hideArray: any = []
  getVariantDetails(obj: any, index:any) {
    this.indexValue = index
      if (this.objectList.includes(obj)) {
        this.objectList = this.objectList.filter((data: any) => {
          return data != obj
        })
        this.showArray[this.indexValue] = !this.showArray[this.indexValue]
      }
      else {
        this.objectList.push(obj)
        this.showArray[this.indexValue] = true
      }
    let obj1: number = +obj
    this.service.getVariantSummaryDetails(obj1).subscribe((data) => {
      this.variant = data
      let a = [];
      let b = [];
      for (let i in this.variant) {
        a.push(i)
        b.push(this.variant[i])
      }
      this.tableData1[index] = a
      this.tableData2[index] = b
      this.tableTit[index] = this.tableData1[index][0];
      this.tableTit1[index] = this.tableData1[index][1];
      this.tableTit2[index] = this.tableData1[index][2];
      this.tabData[index] = this.tableData2[index][0];
      this.tabData1[index] = this.tableData2[index][1];
      this.tabData2[index] = this.tableData2[index][2];
    })
  }
}
